module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/188-peru-78ceb31eeb2d574c9011ed27fbcb4af3.svg";